<template>
  <ContentLayout
    :title="$t('label_essweb_holiday_list_title')"
    :addBtn="hasBtn('add-admin-public-holiday')"
    backgroundClass="transparent"
    filterable
    @filter="
      (val) => {
        filterPageData = val;
      }
    "
    pad="0"
    @new="toNew"
  >
    <!-- 筛选 -->
    <template v-slot:top-selection="{ filter }">
      <v-sheet class="transparent mr-3">
        <v-menu offset-y v-if="SelectYear !== ''">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              outlined
              :ripple="false"
              color="primary"
              class="text-capitalize pr-1 pl-2"
              >{{
                SelectYear == 0
                  ? $t("label_essweb_holiday_list_tab_allLabbel")
                  : Year[SelectYear]
              }}
              <span class="material-icons-round pl-1">arrow_drop_down</span>
            </v-btn>
          </template>
          <v-list dense>
            <v-list-item
              @click="SelectYear = index"
              v-for="(item, index) in Year"
              :key="`selectstaff---${index}`"
            >
              <v-list-item-title>{{
                item == "all"
                  ? $t("label_essweb_holiday_list_tab_allLabbel")
                  : item
              }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-sheet>
      <Selections2
        :objects="filterObjects"
        small-chip
        @filter="
          filter();
          toFilter(1, filter);
        "
        @update="
          (prop, value, selected) => {
            $fliterValue(filterObjects, prop, value, selected);
          }
        "
        @reset="
          (apply) => {
            $fliterValue(filterObjects, null, null);
            if (apply) {
              filter();
              toFilter(1, filter);
            }
          }
        "
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <Tabler
        :headers="headers"
        :items="desserts"
        :height="$vuetify.breakpoint.height - 275 - 48"
        :filter-page-data="filterPageData"
        :showSelect="showSelect"
        :totalCount="totalCount"
        @change="
          (page, perpage, callback, data) => {
            getList(data, page, perpage, callback);
          }
        "
      >
        <template v-slot:item.name="{ item }">{{
          $getCommonLangValue(item.holiday_name)
        }}</template>
        <template v-slot:item.date="{ item }">{{
          $getDateTime(item.holiday_utc_date, "YYYY/MM/DD")
        }}</template>
        <template v-slot:item.zone="{ item }">{{
          $getUtcByCode(item.holiday_time_zone)
        }}</template>

        <template v-slot:item.action="{ item }">
          <tableListTools
            :uuid="item.uuid"
            :delBtn="hasBtn('delete-admin-public-holiday')"
            :editBtn="hasBtn('edit-admin-public-holiday')"
            :viewBtn="hasBtn('view-admin-public-holiday')"
            :title="$t('label_essweb_holiday_list_title')"
            @delete="toDelete"
            @edit="toEdit"
            @view="toEdit"
          />
        </template>
      </Tabler>
    </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
export default {
  name: "PublicHoliday",
  computed: {
    // Year() {
    //   let arr = ["all"];
    //   this.allHoliday.forEach((item) => {
    //     if (item.year) arr.push(item.year);
    //   });
    //   return this.$UniqueArry(arr);
    // },
  },
  mounted() {
    this.getBtnPermissionList();
    this.getDate();
    this.getList(null, 1, this.$tableSetting.perPageSize, null);
  },
  data() {
    return {
      search: "",
      showSelect: false,
      totalCount: 0,
      SelectYear: 0,
      Year: ["all"],
      selected: [],
      allHoliday: [],
      page: 1,
      headers: [
        {
          text: "label_essweb_holiday_list_publicHolidayLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.holiday_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_holiday_list_dateLabel",
          value: "date",
          align: "start",
          sortable: true,
          sort: (prop, desc, calback) => {
            return this.$sortList(
              this.desserts,
              "holiday_utc_date",
              desc ? true : false,
              "datetime"
            ).then((res) => {
              calback(desc);
              this.desserts = res;
            });
          },
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      filterObjects: [
        {
          type: "daterange",
          sequence: 0,
          name: "date",
          position: "right",
          label: "label_essweb_holiday_list_dateLabel",

          value: "",
          data: {
            api: "",
            max: "",
            min: "",
            args: {},
          },
        },
      ],
      filterPageData: null,
    };
  },
  watch: {
    SelectYear(val) {
      const that = this;
      this.desserts = [];
      this.toFilter(1, () => {
        this.$store.dispatch("resetTable", new Date().getTime());
      });
      // if (val == 0) {
      //   that.desserts = this.allHoliday;
      // } else {
      //   this.allHoliday.forEach(function (item) {
      //     if (item.year == that.Year[val]) {
      //       that.desserts.push(item);
      //     }
      //   });
      // }
    },
  },
  methods: {
    activated(refresh) {
      const that = this;
      if (refresh == 0) {
        this.filterable = false;
        this.$fliterValue(this.filterObjects, null, null);
        // if (this.page !== null) {
        this.desserts = [];
        this.getList(null, 1, this.$tableSetting.perPageSize, () => {
          that.$store.dispatch("resetTable", new Date().getTime());
        });
        // }
      }
      if (refresh == 1) {
        if (this.page !== null) {
          this.toFilter(null, () => {});
        } else {
          this.toFilter(1, () => {
            that.$store.dispatch("resetTable", new Date().getTime());
          });
        }
      }
    },
    toFilter(tab, callback) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {};
      object.map((item) => {
        if (item["name"] == "date") {
          data["start_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[0] : ""
          );
          data["end_date"] = that.$getTimeValue(
            item.value ? item.value.split(" - ")[1] : ""
          );
        }
      });
      if (tab) {
        this.getList(data, 1, this.$tableSetting.perPageSize, callback);
      } else {
        this.getList(
          data,
          this.page ? this.page : 1,
          this.pagesize ? this.pagesize : this.$tableSetting.perPageSize,
          callback
        );
      }
    },
    getDate() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/get-holiday-list/",
        data: {
          cpage: 1,
          mode: "year",
          pagesize: 20,
        },
      }).then((res) => {
        that.Year = ["all"];
        res.data.map((item) => {
          that.Year.push(item["year"]);
        });
      });
    },
    getList: function (data, page, perpage, callback) {
      const that = this;
      let filter = {
        cpage: page,
        pagesize: perpage,
      };
      if (this.SelectYear != 0) {
        filter["year"] = this.Year[this.SelectYear];
      }
      if (data) {
        data["cpage"] = page;
        data["pagesize"] = perpage;
        if (this.SelectYear != 0) {
          data["year"] = this.Year[this.SelectYear];
        }
      }

      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/get-holiday-list/",
        data: data ? data : filter,
      }).then((res) => {
        // 排序
        res.data.sort((objectN, objectM) => {
          var valueN = objectN["holiday_utc_date"];
          var valueM = objectM["holiday_utc_date"];
          if (valueN < valueM) return 1;
          else if (valueN > valueM) return -1;
          else return 0;
        });
        that.allHoliday = res.data;
        that.desserts = res.data;
        that.totalCount = res.totalcount;
        callback ? callback(page, perpage, data) : null;
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    toNew: function () {
      this.$toPage("/admin/public-holiday/add", {});
    },
    toDelete: function (uuid) {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_holi_holiday_day",
        url: "/holiday/delete-holiday-table/",
        data: { uuids: uuid },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_holiday_list_deleteHolidaySuccessLabel"
          ),
          type: "success",
        });
        that.desserts = that.desserts.filter((ele) => ele.uuid !== uuid);
      });
    },
    toEdit: function (uuid, action) {
      this.$toPage(
        (action == "edit"
          ? "/admin/public-holiday/edit/"
          : "/admin/public-holiday/detail/") + uuid
      );
    },
  },
};
</script>
<style scoped>
.leftYear:hover::-webkit-scrollbar {
  display: inline-block;
  width: 5px;
}
</style>
